export const encodeImageUrl = (image_url) => {
  return `"${encodeURI(image_url)}"`;
};



// WEBPACK FOOTER //
// ./src/app/utils/encodeImage.js